import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["htmlWidth", "htmlHeight", "alt"],
    _excluded2 = ["className", "id", "src", "size", "isRounded", "fallbackSrc", "objectFit", "onError", "onLoad", "ignoreFallback"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cx from 'classnames';
import { useEffect, useState, forwardRef, useRef } from 'react';
import { prefix } from '../../tools/settings';
import { StyledImage } from './Image.styles';
import { jsx as _jsx } from "react/jsx-runtime";
export var useHasImageLoaded = function useHasImageLoaded(_ref) {
  var src = _ref.src,
      onLoad = _ref.onLoad,
      onError = _ref.onError;
  var isMounted = useRef(true);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasLoaded = _useState2[0],
      setHasLoaded = _useState2[1];

  useEffect(function () {
    if (!src) {
      return;
    }

    var image = new window.Image();
    image.src = src;

    image.onload = function (event) {
      if (isMounted.current) {
        setHasLoaded(true);
        onLoad && onLoad(event);
      }
    };

    image.onError = function (event) {
      if (isMounted.current) {
        setHasLoaded(false);
        onError && onError(event);
      }
    };
  }, [src, onLoad, onError]);
  useEffect(function () {
    return function () {
      isMounted.current = false;
    };
  }, []);
  return hasLoaded;
};
var NativeImage = forwardRef(function (_ref2, ref) {
  var htmlWidth = _ref2.htmlWidth,
      htmlHeight = _ref2.htmlHeight,
      alt = _ref2.alt,
      props = _objectWithoutProperties(_ref2, _excluded);

  return _jsx(StyledImage, _objectSpread({
    width: htmlWidth,
    height: htmlHeight,
    ref: ref,
    alt: alt
  }, props));
});
var Image = forwardRef(function (_ref3, ref) {
  var _cx;

  var customClassName = _ref3.className,
      id = _ref3.id,
      src = _ref3.src,
      size = _ref3.size,
      isRounded = _ref3.isRounded,
      fallbackSrc = _ref3.fallbackSrc,
      _ref3$objectFit = _ref3.objectFit,
      objectFit = _ref3$objectFit === void 0 ? 'cover' : _ref3$objectFit,
      onError = _ref3.onError,
      onLoad = _ref3.onLoad,
      ignoreFallback = _ref3.ignoreFallback,
      rest = _objectWithoutProperties(_ref3, _excluded2);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-image"), true), _defineProperty(_cx, "".concat(prefix, "-image--rounded"), isRounded), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  var hasLoaded = useHasImageLoaded({
    src: src,
    onLoad: onLoad,
    onError: onError
  });
  var imageProps;

  if (ignoreFallback) {
    imageProps = {
      src: src,
      onLoad: onLoad,
      onError: onError
    };
  } else {
    imageProps = {
      src: hasLoaded ? src : fallbackSrc
    };
  }

  return _jsx(NativeImage, _objectSpread(_objectSpread({
    ref: ref,
    className: className,
    id: id,
    size: size,
    objectFit: objectFit
  }, imageProps), rest));
});
Image.displayName = 'Image';
export default Image;